export default class rest {
    restUrl;

    constructor() {
        this.restUrl = 'http://cd.lacran.com/rest/';
    }

    formatParams(params) {
        if (!params) {
            return '';
        }
        return "?" + Object
            .keys(params)
            .map(function (key) {
                return key + "=" + encodeURIComponent(params[key])
            })
            .join("&")
    }

    addParam(url, params) {
        let accessToken = localStorage.getItem('access-token');
        if (accessToken) {
            if (!params) {
                params = {};
            }
            params['access-token'] = accessToken;
        }
        return url + this.formatParams(params);
    }

    get(url, res, error, progress) {
        let xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            res(xhr.responseText);
        });
        xhr.addEventListener('error', (e) => {
            if (e)
                error(e);
        });
        xhr.addEventListener('abort', (e) => {
            if (e)
                error(e);
        });

        xhr.open('GET', url);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send();
        if (progress) {
            xhr.addEventListener('progress', (e) => {
                if (e.loaded > e.total)
                    progress(100);
                else
                    progress(e.loaded / e.total);
            });
        }
        if (xhr.status !== 200 && xhr.status !== 0) {
            error(xhr)
        }
    }

    post(url, data, res, error) {
        let xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            res(xhr.responseText);
        });
        xhr.addEventListener('error', (e) => {
            error(e);
        });
        xhr.addEventListener('abort', (e) => {
            error(e);
        });

        xhr.open('POST', url);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send(JSON.stringify(data));
        if (xhr.status !== 200 && xhr.status !== 0) {
            error(xhr)
        }
    }

    Recive(apiUrl, params, res, error, progress) {
        if (!error)
            error = (e) => {
                console.log(e);
            };

        this.get(this.addParam(this.restUrl + apiUrl, params), res, error, progress);
    }

    Send(apiUrl, params, data, res, error) {
        this.post(this.addParam(this.restUrl + apiUrl, params), data, res, error);
    }

    Auth(login, password, res, error) {
        this.Send('user/login', '', {
            "identity": login,
            "password": password
        }, res, error)
    }

    checkPin(pincode, res, error) {
        this.Send('posusers/login', '', {
            'pincode': pincode
        }, res, error);
    }

    getNewName(resFunc, errorFunc) {
        this.Recive("tsd/get-new-name", '', (data) => {
            resFunc(data.replace('"', '').replace('"', ''));
        }, (e) => {
            errorFunc();
        });
    }

    saveDoc(data, filename, resFunc, resError) {
        this.Send('tsd/save-doc', {
                filename: filename
            },
            data, (success) => {
                resFunc(success);
            }, (e) => {
                resError(e)
            });
    }

    saveCheck(data, resFunc, errorFunc) {
        this.Send('tsd/save-check', {}, data, (success) => {
            resFunc(success);
        }, (error) => {
            resFunc(error);
        });
    }

}
